import { Button, Dialog, DialogContent, Typography } from '@mui/material';
import { PinataDialogTitle } from '../../components/Common/MuiComponents';

interface DeleteKeyModalProps {
  confirmDeleteKey: () => void;
  keyInfo: any;
  deleteKeyModalOpen: boolean;
  setDeleteKeyModalOpen: (open: boolean) => void;
}

const DeleteKeyModal = ({
  confirmDeleteKey,
  keyInfo,
  deleteKeyModalOpen,
  setDeleteKeyModalOpen
}: DeleteKeyModalProps) => {
  return (
    <Dialog open={deleteKeyModalOpen} onClose={() => setDeleteKeyModalOpen(!deleteKeyModalOpen)}>
      <PinataDialogTitle onClose={() => setDeleteKeyModalOpen(false)}>Revoke API Key</PinataDialogTitle>
      <DialogContent dividers>
        <div>
          <Typography variant={'h6'}>Are you sure you want to revoke this key?</Typography>
          <p>{keyInfo.key}</p>
          <p>This cannot be undone.</p>
        </div>

        <Button onClick={confirmDeleteKey} color={'error'}>
          Revoke Key
        </Button>
        <Button onClick={() => setDeleteKeyModalOpen(false)} variant={'text'} color={'primary'}>
          Cancel
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteKeyModal;
